import { render, staticRenderFns } from "./SectionLandingPageInformation.vue?vue&type=template&id=e1ffcca4&scoped=true&"
import script from "./SectionLandingPageInformation.vue?vue&type=script&lang=js&"
export * from "./SectionLandingPageInformation.vue?vue&type=script&lang=js&"
import style0 from "./SectionLandingPageInformation.vue?vue&type=style&index=0&id=e1ffcca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ffcca4",
  null
  
)

export default component.exports